module.exports = __webpack_public_path__ + "add4dec0b2fe285d2ac67e925e7a7d3f.svg";